// extracted by mini-css-extract-plugin
export var arrow = "content-block-module--arrow--810e9";
export var arrowContainer = "content-block-module--arrowContainer--4abab";
export var button = "content-block-module--button--2d7e4";
export var circle = "content-block-module--circle--76a45";
export var circleImage = "content-block-module--circleImage--d712b";
export var circleImageContainer = "content-block-module--circleImageContainer--cb09a";
export var content = "content-block-module--content--15151";
export var contentBlock = "content-block-module--contentBlock--244c4";
export var mainContent = "content-block-module--mainContent--5c867";
export var moveArrow = "content-block-module--moveArrow--45cf2";
export var roundImageCircle = "content-block-module--roundImageCircle--ebb93";
export var squareImage = "content-block-module--squareImage--5b89e";
export var squareImageContainer = "content-block-module--squareImageContainer--3dfce";
export var structuredTextContainer = "content-block-module--structuredTextContainer--817d0";